import "./VehiclesDetailsTools.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { openDrawer } from "../../../../../slices/drawerSlice";
import { openModal } from "../../../../../slices/modalSlice";

import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";

import VehiclesDetailsHeader from "../VehiclesDetailsHeader/VehiclesDetailsHeader";
import VehicleDeleteModal from "../../../VehicleDeleteModal/VehicleDeleteModal";
import VehiclesEdit from "../../../VehiclesEdit/VehiclesEdit";
import VehiclesEditFooter from "../../../VehiclesEdit/components/VehiclesEditFooter/VehiclesEditFooter";

import { TextButton } from "../../../../../common-components/Buttons/Buttons";

const VehiclesDetailsTools = ({id}) => {
    const dispatch = useDispatch();

    const handleOpen = () => {
        dispatch(openModal({content: <VehicleDeleteModal id={id}/>, closeable: true}));
    }

    const handleOpenDrawer = () => {
        dispatch(openDrawer({content: <VehiclesEdit id={id}/>, footer: <VehiclesEditFooter id={id}/>}));
    }

    return (
        <div className={"vehicles-details-tools"}>
            <div className={"vehicles-details-tools_container"}>
                <div className={"vehicles-details-tools_header"}>
                    <VehiclesDetailsHeader id={id}/>
                </div>
                <div className={"vehicles-details-tools_buttons"}>
                    <TextButton Icon={Edit} title={"Редактировать"} onClick={handleOpenDrawer} active={true}/>
                    <TextButton Icon={Delete} title={"Удалить"} onClick={handleOpen} active={true}/>
                </div>
            </div>
        </div>
    )
}

export default VehiclesDetailsTools;